webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mtvConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mtvServers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var mtvConfig = {
  APIList: {
    loginImgCode: '/server/captcha/login/generate',
    resetpwdImgCode: '/server/captcha/forgotpwd/generate',
    sendMsg: '/server/sms/login/code',
    sendVoiceMsg: '/server/sms/login/voice',
    accountLogin: '/server/user/login/account',
    codeLogin: '/server/user/login/sms',
    QQLogin: '/server/sns/auth/show?source=qq',
    WXLogin: '/server/sns/auth/show?source=wx',
    validateAccount: '/server/account/validate',
    resetpwdSendMsg: '/server/account/send/forgotpwd/code',
    resetpwdValidate: '/server/account/forgotpwd/validate',
    resetPwd: '/server/account/forgotpwd/reset',
    logOut: '/server/user/logout'
  },
  urlList: {
    Login: {
      path: '/login',
      name: 'Login'
    },
    LoginCode: {
      path: '/logincode',
      name: 'LoginCode'
    },
    ResetGetAccount: {
      path: '/resetpwd1',
      name: 'ResetGetAccount'
    },
    ResetGetCode: {
      path: '/resetpwd2',
      name: 'ResetGetCode'
    },
    ResetSetPwd: {
      path: '/resetpwd3',
      name: 'ResetSetPwd'
    },
    ResetpwdSuccess: {
      path: '/resetpwd4',
      name: 'ResetpwdSuccess'
    },
    LoginSuccess: {
      path: '/loginsuccess',
      name: 'LoginSuccess'
    },
    LoginFail: {
      path: '/loginfail',
      name: 'LoginFail'
    }
  },
  errorData: { status: -200, message: '网络异常' },
  errCode: {
    success: { code: '200', msg: '' },
    code400: { code: '400', msg: '请求参数有误' },
    code401: { code: '401', msg: '帐号不存在' },
    code402: { code: '402', msg: '帐号或密码不正确' },
    code403: { code: '403', msg: '输入的帐号格式有误' },
    code406: { code: '406', msg: '操作太频繁，请稍候重试' },
    code407: { code: '407', msg: '密码格式不正确' },
    code408: { code: '408', msg: '请在60s后再次发送' },
    code409: { code: '409', msg: '今日短信发送已达上限' },
    code102: { code: '102', msg: '图形验证码不正确' },
    code103: { code: '103', msg: '验证码不正确' },
    code106: { code: '106', msg: '发送验证码失败' },
    code107: { code: '107', msg: '通知状态机失败' },
    code108: { code: '108', msg: '获取accesstoken失败' },
    code109: { code: '109', msg: '会话信息失效' },
    code500: { code: '500', msg: '服务端异常' }
  },
  mobileCodeState: {
    disable: 'disable',
    enable: 'enable',
    timeout: 'timeout'
  },
  mobileCodeTxt: {
    disable: '获取验证码',
    enable: '获取验证码',
    timeout: '重新获取'
  },
  submitBtnState: {
    disable: 'disable',
    enable: 'enable'
  },
  sendVoiceMsgBtnState: {
    disable: 'disable',
    enable: 'enable',
    timeout: 'timeout'
  },
  countryList: [{ 'name': '中国大陆', 'code': '86' }, { 'name': '香港', 'code': '852' }, { 'name': '台湾', 'code': '886' }, { 'name': ' 澳门', 'code': '853' }, { 'name': '韩国', 'code': '82' }, { 'name': '日本', 'code': '81' }, { 'name': '美国', 'code': '1' }, { 'name': '加拿大', 'code': '1' }, { 'name': '英国', 'code': '44' }, { 'name': '澳大利亚', 'code': '61' }, { 'name': '新加坡', 'code': '65' }, { 'name': '马来西亚', 'code': '60' }, { 'name': '印度', 'code': '91' }, { 'name': '泰国', 'code': '66' }, { 'name': '德国', 'code': '49' }, { 'name': '意大利', 'code': '39' }, { 'name': '法国', 'code': '33' }, { 'name': '俄罗斯', 'code': '7' }],
  reg: {
    email: /^[\w.-]+@(?:[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,6}$/,
    chinaPhone: /^1\d{10}$/,
    otherPhone: /^\d{6,15}$/,
    imgCode: /^[0-9a-zA-z]{4}$/,
    mobileCode: /^\d{6}$/,
    pwd: /(?![a-z]+$|[0-9]+$|_+$)^[a-zA-Z0-9_]{6,20}$/
  },
  inputType: {
    mobile: 'mobile',
    mobileOrEmail: 'mobileOrEmail'
  },
  mobilePlaceholder: {
    mobile: '手机号码',
    mobileOrEmail: '手机号/邮箱'
  },
  errorMsg: {
    format: {
      account: '帐号格式有误',
      mobile: '手机格式有误',
      imgCode: '图片验证码格式有误',
      mobileCode: '验证码格式有误',
      pwd: '密码格式有误',
      repwd: '密码输入不一致'
    },
    empty: {
      imgCode: '请输入图片验证码',
      account: '请输入帐号',
      mobile: '请输入手机号码',
      mobileCode: '请输入验证码',
      pwd: '请输入密码',
      newpwd: '请输入新密码'
    }
  },
  channelType: {
    bbs: 'bbs',
    home: 'home',
    account: 'account'
  }
};
var ERROR_DATA = mtvConfig.errorData;
var mtvServers = {
  /***
   * 发送请求
   * @param context
   * @param account
   * @param password
   * @returns {Promise}
   */
  appServices: function appServices(context, url, data, headerData) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      context.$http.post(url, data, { headers: headerData }).then(function (res) {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          resolve(ERROR_DATA);
        }
      }, function (res) {
        resolve(ERROR_DATA);
      });
    });
  },
  appServicesGet: function appServicesGet(context, url, data, headerData) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      context.$http.get(url, data, { headers: headerData }).then(function (res) {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          resolve(ERROR_DATA);
        }
      }, function (res) {
        resolve(ERROR_DATA);
      });
    });
  },
  isMobile: function isMobile() {
    var useragent = navigator.userAgent;
    var isIpad = useragent.indexOf('iPad') > -1;
    var ismobile = !!useragent.match(/AppleWebKit.*Mobile.*/) && !isIpad;
    return ismobile;
  },
  getChannelType: function getChannelType(callback) {
    if (!callback) callback = '';
    if (callback.indexOf('bbs') > -1) {
      return mtvConfig.channelType.bbs;
    } else if (callback.indexOf('moretv') > -1) {
      return mtvConfig.channelType.home;
    } else {
      return mtvConfig.channelType.account;
    }
  }
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(140),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(127),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_login__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__page_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_logincode__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_logincode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__page_logincode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_ResetGetAccount__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_ResetGetAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_ResetGetAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_ResetGetCode__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_ResetGetCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__page_ResetGetCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_ResetSetPwd__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_ResetSetPwd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__page_ResetSetPwd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_ResetpwdSuccess__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_ResetpwdSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__page_ResetpwdSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_loginSuccess__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_loginSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__page_loginSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page_LoginFail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page_LoginFail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__page_LoginFail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_LogOut__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_LogOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__page_LogOut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_userinfo__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_userinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__page_userinfo__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'LoginCode',
    component: __WEBPACK_IMPORTED_MODULE_3__page_logincode___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__page_login___default.a
  }, {
    path: '/logincode',
    name: 'LoginCode',
    component: __WEBPACK_IMPORTED_MODULE_3__page_logincode___default.a
  }, {
    path: '/resetpwd1',
    name: 'ResetGetAccount',
    component: __WEBPACK_IMPORTED_MODULE_4__page_ResetGetAccount___default.a
  }, {
    path: '/resetpwd2',
    name: 'ResetGetCode',
    component: __WEBPACK_IMPORTED_MODULE_5__page_ResetGetCode___default.a
  }, {
    path: '/resetpwd3',
    name: 'ResetSetPwd',
    component: __WEBPACK_IMPORTED_MODULE_6__page_ResetSetPwd___default.a
  }, {
    path: '/resetpwd4',
    name: 'ResetpwdSuccess',
    component: __WEBPACK_IMPORTED_MODULE_7__page_ResetpwdSuccess___default.a
  }, {
    path: '/loginsuccess',
    name: 'LoginSuccess',
    component: __WEBPACK_IMPORTED_MODULE_8__page_loginSuccess___default.a
  }, {
    path: '/loginfail',
    name: 'LoginFail',
    component: __WEBPACK_IMPORTED_MODULE_9__page_LoginFail___default.a
  }, {
    path: '/logout',
    name: 'LogOut',
    component: __WEBPACK_IMPORTED_MODULE_10__page_LogOut___default.a
  }, {
    path: '/userInfo',
    name: 'Userinfo',
    component: __WEBPACK_IMPORTED_MODULE_11__page_userinfo___default.a
  }]
}));

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__toast_vue__);


var ToastObj = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_1__toast_vue___default.a);
var instance = void 0;
var toast = function toast(options) {
  // 如果存在toast，并且
  if (instance && instance.isShow) return;
  options = options || {};
  instance = new ToastObj({
    data: options
  });
  // 渲染
  instance.vm = instance.$mount('#toast');
  instance.vm.toastShow = true;
};
/* harmony default export */ __webpack_exports__["a"] = (toast);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(139),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toast_toast_js__ = __webpack_require__(44);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.headers = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toast = __WEBPACK_IMPORTED_MODULE_4__toast_toast_js__["a" /* default */];
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['options', 'imgCodeErrData'],
  data: function data() {
    return {
      imgCode: '',
      imgSrc: '',
      errMsgShow: false,
      errMsg: '',
      isMobile: false
    };
  },
  created: function created() {
    this.isMobile = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].isMobile();
    this.imgSrc = this.options.imgSrc + '?' + new Date().getTime();
  },

  watch: {
    options: function options(newValue, oldValue) {
      this.imgCodeChange();
      this.errMsgShow = false;
    },
    imgCode: function imgCode(newValue, oldValue) {
      var _this = this;

      var that = this;
      that.$emit('imgCodeSuccess', newValue);
      if (newValue.length === 4) {
        if (this.imgCodeBlur()) {
          if (this.options.inputType !== __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobileOrEmail) {
            this.errMsgShow = false;
            __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServices(this, this.options.sendUrl, { mobile: this.options.mobile, ncode: this.options.ncode, imgcode: this.imgCode }).then(function (res) {
              if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
                that.errmsgShow = false;
                that.$emit('mobileCodeSendSuccess', that.options.isVoice);
              } else {
                _this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg);
                that.imgCodeChange();
                that.imgCode = '';
              }
            });
          }
        }
      } else if (newValue.length === 0) {
        if (this.options.inputType === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobileOrEmail) {
          that.$emit('imgCodeSuccess', newValue);
        }
      }
    },
    imgCodeErrData: function imgCodeErrData(newValue) {
      this.imgCodeChange();
      this.showErrMsg(newValue.errMsg);
    }
  },
  methods: {
    imgCodeBlur: function imgCodeBlur() {
      if (this.imgCode.length === 0) {
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.imgCode.test(this.imgCode)) {
        this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.format.imgCode);
        return false;
      }
      return true;
    },
    imgCodeFocus: function imgCodeFocus() {
      this.errMsgShow = false;
    },
    imgCodeChange: function imgCodeChange() {
      this.imgSrc = this.options.imgSrc + '?' + new Date().getTime();
      this.imgCode = '';
    },
    showErrMsg: function showErrMsg(msg) {
      if (this.isMobile) {
        this.$toast({ toastMsg: msg });
      }
      this.errMsgShow = true;
      this.errMsg = msg;
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mobileCode',
  props: ['mobileCodeBtnState', 'imgCode', 'inputType', 'codeErrData', 'sendMsg', 'sendMsgTimer'],
  data: function data() {
    return {
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      errMsgShow: false,
      errMsg: '',
      timer: 60,
      timeOutInter: null,
      verifyCode: '',
      codeBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable,
      isMobile: false,
      sendMsgs: false
    };
  },

  watch: {
    sendMsgTimer: function sendMsgTimer() {
      this.verifyCode = '';
      this.errMsgShow = false;
    },
    sendMsg: function sendMsg(newValue) {
      this.sendMsgs = newValue;
    },
    codeErrData: function codeErrData(newValue) {
      this.showErrMsg(newValue.errMsg);
    },
    mobileCodeBtnState: function mobileCodeBtnState(newValue) {
      this.codeBtnState = newValue;
      if (newValue === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.timeout) {
        var that = this;
        that.timer = 60;
        that.timeOutInter = setInterval(function () {
          if (that.timer === 1) {
            clearInterval(that.timeOutInter);
            that.$emit('mobileCodeBtnEnable');
          }
          that.timer--;
        }, 1000);
      }
    },
    verifyCode: function verifyCode(newValue) {
      var that = this;
      that.$emit('mobileCodeSuccess', newValue);
    }
  },
  created: function created() {
    this.isMobile = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].isMobile();
  },

  methods: {
    showImgCode: function showImgCode() {
      if (this.inputType === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile) {
        this.$emit('showImgCode');
      } else {
        this.sendResetMsg();
      }
    },
    mobileCodeBlur: function mobileCodeBlur() {
      if (this.verifyCode.length === 0) {
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.mobileCode.test(this.verifyCode)) {
        this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.format.mobileCode);
      } else {
        this.errMsgShow = false;
      }
    },
    mobileCodeFocus: function mobileCodeFocus() {
      this.errMsgShow = false;
    },
    sendResetMsg: function sendResetMsg() {
      var _this = this;

      var that = this;
      if (that.imgCode.length !== 4) return;
      this.codeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable;
      __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServices(this, __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.resetpwdSendMsg, { imgcode: that.imgCode }).then(function (res) {
        if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
          that.errMsgShow = false;
          that.verifyCode = '';
          that.errmsgShow = false;
          that.mobileCodeSendSuccess();
          that.sendMsgs = true;
        } else {
          _this.codeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.enable;
          that.$emit('mobileCodeSendFail', res.status);
        }
      });
    },

    // 倒计时开启
    mobileCodeSendSuccess: function mobileCodeSendSuccess() {
      var that = this;
      that.codeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.timeout;
      that.timer = 60;
      that.timeOutInter = setInterval(function () {
        if (that.timer === 1) {
          clearInterval(that.timeOutInter);
          that.mobileCodeBtnEnable();
        }
        that.timer--;
      }, 1000);
    },

    // 倒计时完成
    mobileCodeBtnEnable: function mobileCodeBtnEnable() {
      if (this.imgCode.length > 0) {
        this.codeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.enable;
      } else {
        this.codeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable;
      }
    },
    showErrMsg: function showErrMsg(msg) {
      if (this.isMobile) {
        this.$toast({ toastMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.format.mobileCode });
      }
      this.errMsgShow = true;
      this.errMsg = msg;
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mobileInput',
  props: ['inputType', 'errData'],
  data: function data() {
    return {
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      errMsgShow: false,
      errMsg: '',
      mobile: '',
      countryListShow: false,
      countryList: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].countryList,
      countryCodeIndex: 0,
      isMobile: false
    };
  },

  watch: {
    mobile: function mobile(newValue, oldValue) {
      if (newValue.length > 0) {
        this.$emit('btnEnable', newValue, this.countryCodeIndex);
      } else {
        this.$emit('btnDisable', newValue);
      }
    },
    countryCodeIndex: function countryCodeIndex(newValue, oldValue) {
      this.$emit('hideImgCode', newValue);
    },
    errData: function errData(newValue) {
      this.showErrMsg(newValue.errMsg);
    }
  },
  created: function created() {
    this.isMobile = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].isMobile();
    var that = this;
    window.onclick = function () {
      that.countryListShow = false;
    };
  },

  methods: {
    // 显示国家列表
    showCountry: function showCountry() {
      this.countryListShow = true;
    },

    // 选择国家
    countryCheck: function countryCheck(index) {
      this.countryCodeIndex = index;
      this.countryListShow = false;
      this.mobileBlur();
    },

    // 隐藏图形验证码
    mobileFocus: function mobileFocus() {
      this.errMsgShow = false;
      this.$emit('hideImgCode');
    },

    // 验证手机或邮箱格式
    mobileBlur: function mobileBlur() {
      if (this.mobile.length === 0) {
        return;
      }
      if (this.inputType === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile) {
        if (this.countryCodeIndex === 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.chinaPhone.test(this.mobile) || this.countryCodeIndex !== 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.otherPhone.test(this.mobile)) {
          this.errMsgShow = false;
        } else {
          this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.format.mobile);
        }
      } else {
        if (!__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.email.test(this.mobile)) {
          if (this.countryCodeIndex === 0 && !__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.chinaPhone.test(this.mobile) || this.countryCodeIndex !== 0 && !__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.otherPhone.test(this.mobile)) {
            this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.format.account);
          } else {
            this.errMsgShow = false;
          }
        } else {
          this.errMsgShow = false;
        }
      }
    },
    showErrMsg: function showErrMsg(msg) {
      if (this.isMobile) {
        this.$toast({ toastMsg: msg });
      }
      this.errMsgShow = true;
      this.errMsg = msg;
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      isMobile: false,
      search: window.location.search.replace('?', '&'),
      channel: ''
    };
  },
  created: function created() {
    this.isMobile = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].isMobile();
    this.channel = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].getChannelType(this.$route.query.callback);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      msg: '处理中…'
    };
  },
  created: function created() {
    this.logout();
  },

  methods: {
    // 登出
    logout: function logout() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServicesGet(this, __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.logOut, {}).then(function (res) {
        if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
          document.cookie = 'nickname=;path=/;domain=.ismartv.cn';
          document.cookie = 'isLogin=;path=/;domain=.ismartv.cn';
          if (that.$route.query.callback) {
            location.href = that.$route.query.callback;
          } else {
            window.location.href = 'http://m.ismartv.cn';
          }
        } else {
          that.msg = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg;
        }
      });
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      type: 'qq',
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      isMobile: false,
      linkUrl: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.QQLogin
    };
  },
  created: function created() {
    this.isMobile = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].isMobile();
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.type === 'wx') {
      this.linkUrl = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.WXLogin + '&isMobile=' + this.isMobile;
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileInput__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_mobileInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mobileCode__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mobileCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_mobileCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgCode__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_imgCode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { MobileInput: __WEBPACK_IMPORTED_MODULE_1__components_mobileInput___default.a, MobileCode: __WEBPACK_IMPORTED_MODULE_2__components_mobileCode___default.a, ImgCode: __WEBPACK_IMPORTED_MODULE_3__components_imgCode___default.a },
  data: function data() {
    return {
      step: 3,
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      // 用户填写
      mobile: '',
      // 接口返回
      account: '',
      countryCodeIndex: 0,
      submitBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable,
      inputType: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile,
      errData: {},
      search: window.location.search
    };
  },
  created: function created() {},

  methods: {
    // 按钮可用
    btnEnable: function btnEnable(mobile, countryCodeIndex) {
      this.mobile = mobile;
      this.countryCodeIndex = countryCodeIndex;
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
    },

    // 按钮不可用
    btnDisable: function btnDisable(mobile) {
      this.mobile = mobile;
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
    },
    hideImgCode: function hideImgCode(countryCodeIndex) {
      this.countryCodeIndex = countryCodeIndex;
    },

    // 验证帐号格式
    getAccountType: function getAccountType() {
      if (this.countryCodeIndex === 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.chinaPhone.test(this.mobile) || this.countryCodeIndex !== 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.otherPhone.test(this.mobile)) {
        this.inputType = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile;
        return true;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.email.test(this.mobile)) {
          this.inputType = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobileOrEmail;
          return true;
        } else {
          return false;
        }
      }
    },

    // 获取用户信息
    getAccount: function getAccount() {
      var _this = this;

      if (!this.getAccountType()) return;
      var that = this;
      var data = {};
      if (this.inputType === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile) {
        data = { account: this.mobile, ncode: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].countryList[this.countryCodeIndex].code };
      } else {
        data = { account: this.mobile };
      }
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServices(this, __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.validateAccount, data).then(function (res) {
        if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
          var nextRoute = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].urlList.ResetGetCode;
          nextRoute.query = {};
          if (_this.$route.query.callback) {
            nextRoute.query.callback = _this.$route.query.callback;
          }
          if (_this.$route.query.connectid) {
            nextRoute.query.connectid = _this.$route.query.connectid;
          }
          nextRoute.params = { account: res.data, inputType: _this.inputType };
          _this.$router.push(nextRoute);
        } else {
          _this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
          that.errData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg };
        }
      });
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileCode__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_mobileCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_imgCode__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_imgCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_imgCode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { MobileCode: __WEBPACK_IMPORTED_MODULE_1__components_mobileCode___default.a, ImgCode: __WEBPACK_IMPORTED_MODULE_2__components_imgCode___default.a },
  data: function data() {
    return {
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      account: '',
      inputType: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile,
      imgCodeData: {},
      imgCodeErrData: {},
      verifyCode: '',
      mobileCodeBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable,
      imgCode: '',
      callback: '',
      codeErrData: {},
      submitBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable
    };
  },
  created: function created() {
    if (this.$route.params.inputType === undefined || this.$route.params.account === undefined) {
      this.$router.push(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].urlList.ResetGetAccount.path + window.location.search);
    }
    this.inputType = this.$route.params.inputType;
    this.account = this.$route.params.account;
    this.imgCodeData = { inputType: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobileOrEmail, imgSrc: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.resetpwdImgCode };
  },

  methods: {
    // 填写图形验证码格式正确
    imgCodeSuccess: function imgCodeSuccess(imgCode) {
      if (imgCode.length === 0) {
        this.mobileCodeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable;
        return;
      }
      this.mobileCodeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.enable;
      this.imgCode = imgCode;
    },

    // 填写手机验证码
    mobileCodeSuccess: function mobileCodeSuccess(mobileCode) {
      this.verifyCode = mobileCode;
      if (this.verifyCode.length === 0) {
        this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      } else {
        this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
      }
    },

    // 发送短信验证码错误
    mobileCodeSendFail: function mobileCodeSendFail(code) {
      this.imgCodeErrData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + code].msg };
    },

    // 验证码提交
    verificationCode: function verificationCode() {
      var _this = this;

      if (!__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.mobileCode.test(this.verifyCode)) return;
      var that = this;
      var data = { verifyCode: this.verifyCode };
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServices(this, __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.resetpwdValidate, data).then(function (res) {
        if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
          var nextRoute = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].urlList.ResetSetPwd;
          nextRoute.query = {};
          if (_this.$route.query.callback) {
            nextRoute.query.callback = _this.$route.query.callback;
          }
          if (_this.$route.query.connectid) {
            nextRoute.query.connectid = _this.$route.query.connectid;
          }
          nextRoute.params = { verifyCode: that.verifyCode, account: that.account };
          _this.$router.push(nextRoute);
        } else {
          _this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
          if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.code103.code) {
            that.codeErrData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg };
          } else {
            that.imgCodeErrData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg };
          }
        }
      });
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      verifyCode: '',
      pwd: '',
      repwd: '',
      pwdData: { errMsgShow: false, errMsg: '' },
      repwdData: { errMsgShow: false, errMsg: '' },
      submitBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable,
      callback: '',
      isMobile: ''
    };
  },

  watch: {
    pwd: function pwd(newValue) {
      if (newValue.length > 0) {
        this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
      } else {
        this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      }
    },
    repwd: function repwd(newValue) {
      if (newValue.length > 0) {
        this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
      } else {
        this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      }
    }
  },
  created: function created() {
    this.isMobile = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].isMobile();
    if (this.$route.params.verifyCode === undefined || this.$route.params.account === undefined) {
      this.$router.push(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].urlList.ResetGetAccount.path + window.location.search);
    }
    if (this.$route.query.callback) {
      this.callback = this.$route.query.callback;
    }
    this.account = this.$route.params.account;
    this.verifyCode = this.$route.params.verifyCode;
  },

  methods: {
    resetPwd: function resetPwd() {
      var _this = this;

      if (!__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.pwd.test(this.pwd) || this.repwd !== this.pwd) return;
      var that = this;
      var data = { verifyCode: this.verifyCode, password: this.pwd };
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServices(this, __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.resetPwd, data).then(function (res) {
        if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
          var nextRoute = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].urlList.ResetpwdSuccess;
          nextRoute.query = {};
          if (_this.$route.query.callback) {
            nextRoute.query.callback = _this.$route.query.callback;
          }
          if (_this.$route.query.connectid) {
            nextRoute.query.connectid = _this.$route.query.connectid;
          }
          nextRoute.params = { account: that.account };
          _this.$router.push(nextRoute);
        } else {
          _this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
          _this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg, false);
        }
      });
    },
    pwdFocus: function pwdFocus() {
      this.pwdData.errMsgShow = false;
    },
    pwdBlur: function pwdBlur() {
      if (this.pwd.length === 0) {
        this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.empty.pwd);
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.pwd.test(this.pwd)) {
        this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.format.pwd, false);
      }
    },
    repwdFocus: function repwdFocus() {
      this.repwdData.errMsgShow = false;
    },
    repwdBlur: function repwdBlur() {
      if (this.repwd !== this.pwd) {
        this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.format.repwd, true);
      }
    },
    showErrMsg: function showErrMsg(msg, isRepwd) {
      if (this.isMobile) {
        this.$toast({ toastMsg: msg });
      }
      if (isRepwd) {
        this.repwdData.errMsgShow = true;
        this.repwdData.errMsg = msg;
      } else {
        this.pwdData.errMsgShow = true;
        this.pwdData.errMsg = msg;
      }
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      account: '',
      timer: 5,
      setTimeOutObj: null
    };
  },
  created: function created() {
    if (this.$route.params.account === undefined) {
      this.$router.push(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].urlList.ResetGetAccount.path + window.location.search);
    }
    this.account = this.$route.params.account;
    this.setTimeOutFun();
  },

  methods: {
    setTimeOutFun: function setTimeOutFun() {
      var that = this;
      that.setTimeOutObj = setInterval(function () {
        if (that.timer === 1) {
          that.toLogin();
        }
        that.timer--;
      }, 1000);
    },
    toLogin: function toLogin() {
      clearTimeout(this.setTimeOutObj);
      var nextRoute = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].urlList.Login;
      nextRoute.query = {};
      if (this.$route.query.callback) {
        nextRoute.query.callback = this.$route.query.callback;
      }
      if (this.$route.query.connectid) {
        nextRoute.query.connectid = this.$route.query.connectid;
      }
      this.$router.push(nextRoute);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileInput__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_mobileInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_otherWay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_otherWay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_otherWay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobileCode__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobileCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_mobileCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_imgCode__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_imgCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_imgCode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { MobileInput: __WEBPACK_IMPORTED_MODULE_1__components_mobileInput___default.a, OtherWay: __WEBPACK_IMPORTED_MODULE_2__components_otherWay___default.a, MobileCode: __WEBPACK_IMPORTED_MODULE_3__components_mobileCode___default.a, ImgCode: __WEBPACK_IMPORTED_MODULE_4__components_imgCode___default.a },
  data: function data() {
    return {
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      submitBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable,
      mobile: '',
      password: '',
      countryCodeIndex: 0,
      inputType: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile,
      errData: {},
      channel: '',
      isMobile: '',
      errMsgShow: false,
      errMsg: '',
      search: window.location.search
    };
  },
  created: function created() {
    this.isMobile = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].isMobile();
    this.channel = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].getChannelType(this.$route.query.callback);
  },

  methods: {
    // 按钮可用
    btnEnable: function btnEnable(mobile, countryCodeIndex) {
      this.mobile = mobile;
      this.countryCodeIndex = countryCodeIndex;
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
    },

    // 按钮不可用
    btnDisable: function btnDisable() {
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
    },

    // 隐藏图形验证码
    getNcode: function getNcode(countryCodeIndex) {
      if (countryCodeIndex !== undefined) {
        this.countryCodeIndex = countryCodeIndex;
      }
    },

    // 验证帐号格式
    getAccountType: function getAccountType() {
      if (this.countryCodeIndex === 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.chinaPhone.test(this.mobile) || this.countryCodeIndex !== 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.otherPhone.test(this.mobile)) {
        this.inputType = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile;
        return true;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.email.test(this.mobile)) {
          this.inputType = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobileOrEmail;
          return true;
        } else {
          return false;
        }
      }
    },

    // 登陆
    login: function login() {
      var _this = this;

      if (!this.getAccountType()) return;
      if (this.password.length === 0) {
        this.showErrMsg(__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.empty.pwd);
        return;
      }
      var that = this;
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      var data = {};
      if (this.inputType === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile) {
        data = { account: this.mobile, ncode: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].countryList[this.countryCodeIndex].code, password: this.password, channel: this.channel };
      } else {
        data = { account: this.mobile, password: this.password, channel: this.channel };
      }
      if (this.$route.query.connectid) {
        data.connectid = this.$route.query.connectid;
      }
      __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServices(this, __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.accountLogin, data).then(function (res) {
        if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
          if (that.$route.query.callback) {
            location.href = that.$route.query.callback;
          } else {
            window.location.href = 'http://m.ismartv.cn';
          }
        } else {
          _this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
          that.errData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg };
        }
      });
    },
    pwdFocus: function pwdFocus() {
      this.errMsgShow = false;
    },
    showErrMsg: function showErrMsg(msg) {
      if (this.isMobile) {
        this.$toast({ toastMsg: msg });
      }
      this.errMsgShow = true;
      this.errMsg = msg;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {
    window.location.href = 'http://m.ismartv.cn';
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileInput__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobileInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_mobileInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_otherWay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_otherWay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_otherWay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobileCode__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobileCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_mobileCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_imgCode__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_imgCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_imgCode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { MobileInput: __WEBPACK_IMPORTED_MODULE_1__components_mobileInput___default.a, OtherWay: __WEBPACK_IMPORTED_MODULE_2__components_otherWay___default.a, MobileCode: __WEBPACK_IMPORTED_MODULE_3__components_mobileCode___default.a, ImgCode: __WEBPACK_IMPORTED_MODULE_4__components_imgCode___default.a },
  data: function data() {
    return {
      CONF: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */],
      imgCodeShow: false,
      imgCodeData: {},
      mobile: '',
      countryCodeIndex: 0,
      verifyCode: '',
      mobileFormatSuccess: false,
      mobileCodeBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable,
      submitBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable,
      errData: {},
      sendOneMsg: false,
      voiceTimer: 60,
      sendVoiceMsgBtnState: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable,
      timeOutInter: null,
      channel: '',
      search: window.location.search,
      codeErrData: {},
      sendMsg: false,
      sendMsgTimer: ''
    };
  },
  created: function created() {
    this.channel = __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].getChannelType(this.$route.query.callback);
    var url = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.sendMsg;
    this.imgCodeData = { 'imgSrc': __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.loginImgCode, 'mobile': this.mobile, 'sendUrl': url, 'ncode': __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].countryList[this.countryCodeIndex].code, 'isVoice': false, inputType: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile };
  },

  methods: {
    // 按钮可用
    btnEnable: function btnEnable(mobile, countryCodeIndex) {
      this.mobile = mobile;
      this.countryCodeIndex = countryCodeIndex;
      if (this.mobileCodeBtnState === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable) {
        this.mobileCodeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.enable;
      }
      if (this.sendVoiceMsgBtnState === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.disable) {
        this.sendVoiceMsgBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.enable;
      }
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
    },

    // 按钮不可用
    btnDisable: function btnDisable(mobile) {
      this.mobile = mobile;
      if (this.mobileCodeBtnState === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.enable) {
        this.mobileCodeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable;
      }
      if (this.sendVoiceMsgBtnState === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.enable) {
        this.sendVoiceMsgBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.disable;
      }
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
    },

    // 显示图形验证码
    showImgCode: function showImgCode(isVoice) {
      if (!this.checkMobile()) return;
      this.imgCodeShow = true;
      var url = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.sendMsg;
      if (isVoice) {
        url = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.sendVoiceMsg;
      }
      this.imgCodeData = { 'imgSrc': __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.loginImgCode, 'mobile': this.mobile, 'sendUrl': url, 'ncode': __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].countryList[this.countryCodeIndex].code, 'isVoice': isVoice, inputType: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].inputType.mobile };
    },

    // 隐藏图形验证码
    hideImgCode: function hideImgCode(countryCodeIndex) {
      if (countryCodeIndex !== undefined) {
        this.sendMsgTimer = new Date().getTime();
        this.countryCodeIndex = countryCodeIndex;
      }
      this.imgCodeShow = false;
    },

    // 填写手机验证码
    mobileCodeSuccess: function mobileCodeSuccess(mobileCode) {
      this.verifyCode = mobileCode;
    },

    // 登陆
    login: function login() {
      var _this = this;

      var that = this;
      if (!this.checkMobile()) return;
      if (this.verifyCode.length === 0) {
        that.codeErrData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errorMsg.empty.mobileCode };
        return;
      } else {
        if (!__WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.mobileCode.test(this.verifyCode)) return;
      }
      this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.disable;
      var data = { mobile: this.mobile, ncode: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].countryList[this.countryCodeIndex].code, verifyCode: this.verifyCode, channel: this.channel };
      if (this.$route.query.connectid) {
        data.connectid = this.$route.query.connectid;
      }
      __WEBPACK_IMPORTED_MODULE_0__services_services__["a" /* mtvServers */].appServices(this, __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].APIList.codeLogin, data).then(function (res) {
        if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.success.code) {
          if (that.$route.query.callback) {
            window.location.href = that.$route.query.callback;
          } else {
            window.location.href = 'http://m.ismartv.cn';
          }
        } else {
          _this.submitBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].submitBtnState.enable;
          if (res.status === __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode.code103.code) {
            that.codeErrData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg };
          } else {
            that.errData = { errMsgShow: true, errMsg: __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].errCode['code' + res.status].msg };
          }
        }
      });
    },

    // 检查手机格式
    checkMobile: function checkMobile() {
      if (this.countryCodeIndex === 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.chinaPhone.test(this.mobile) || this.countryCodeIndex !== 0 && __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].reg.otherPhone.test(this.mobile)) {
        return true;
      } else {
        return false;
      }
    },

    // 倒计时开启
    mobileCodeSendSuccess: function mobileCodeSendSuccess(isVoice) {
      this.sendMsgTimer = new Date().getTime();
      // 语音
      if (isVoice) {
        var that = this;
        that.voiceTimer = 60;
        that.sendVoiceMsgBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.timeout;
        that.timeOutInter = setInterval(function () {
          if (that.voiceTimer === 1) {
            clearInterval(that.timeOutInter);
            that.mobileCodeBtnEnable(isVoice);
          }
          that.voiceTimer--;
        }, 1000);
        // 短信
      } else {
        this.sendMsg = true;
        if (this.countryCodeIndex === 0) this.sendOneMsg = true;
        this.sendVoiceMsgBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.enable;
        this.mobileCodeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.timeout;
      }
      this.imgCodeShow = false;
    },

    // 倒计时完成
    mobileCodeBtnEnable: function mobileCodeBtnEnable(isVoice) {
      if (isVoice) {
        if (this.mobile.length > 0) {
          this.sendVoiceMsgBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.enable;
        } else {
          this.sendVoiceMsgBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].sendVoiceMsgBtnState.disable;
        }
      } else {
        if (this.mobile.length > 0) {
          this.mobileCodeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.enable;
        } else {
          this.mobileCodeBtnState = __WEBPACK_IMPORTED_MODULE_0__services_services__["b" /* mtvConfig */].mobileCodeState.disable;
        }
      }
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      toastMsg: '',
      toastShow: false,
      setTimeOutObj: null
    };
  },

  watch: {
    toastShow: function toastShow(newValue) {
      if (newValue === true) {
        var that = this;
        that.setTimeOutObj = setTimeout(function () {
          that.toastShow = false;
        }, 3000);
      }
    }
  }
});

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(133),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57320d70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(128),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05644939",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(136),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(138),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(130),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-172b0e88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(134),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72a11d27",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(132),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fecb78d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(135),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(141),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f514bc92",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(137),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-ipt mobile-ipt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "input",
    class: {
      'error': _vm.errMsgShow
    },
    attrs: {
      "placeholder": _vm.CONF.mobilePlaceholder[_vm.inputType]
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "focus": _vm.mobileFocus,
      "blur": _vm.mobileBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "country-code"
  }, [_c('div', {
    staticClass: "left-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt font-size14 color-msg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showCountry()
      }
    }
  }, [_vm._v(_vm._s(_vm.countryList[_vm.countryCodeIndex].name))]), _vm._v(" "), _c('div', {
    staticClass: "triangle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showCountry()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errMsgShow && !_vm.isMobile),
      expression: "errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.errMsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countryListShow),
      expression: "countryListShow"
    }],
    staticClass: "country-list"
  }, _vm._l((_vm.countryList), function(countryItem, index) {
    return _c('div', {
      staticClass: "country-item",
      class: {
        'active': _vm.countryCodeIndex == index
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.countryCheck(index)
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(countryItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "code"
    }, [_vm._v("+" + _vm._s(countryItem.code))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "fail"
  }, [_vm._v("参数失效， "), _c('a', {
    attrs: {
      "href": _vm.linkUrl
    }
  }, [_vm._v("点击继续操作")])])])
},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-ipt"
  }, [_c('div', {
    staticClass: "left-part short-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    staticClass: "input",
    class: {
      'error': _vm.errMsgShow
    },
    attrs: {
      "placeholder": "验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "blur": _vm.mobileCodeBlur,
      "focus": _vm.mobileCodeFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-part"
  }, [_c('div', {
    staticClass: "btn-code"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeBtnState == _vm.CONF.mobileCodeState.enable && _vm.sendMsgs),
      expression: "codeBtnState==CONF.mobileCodeState.enable&&sendMsgs"
    }],
    staticClass: "btn active",
    on: {
      "click": function($event) {
        return _vm.showImgCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.CONF.mobileCodeTxt.timeout))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeBtnState == _vm.CONF.mobileCodeState.enable && !_vm.sendMsgs),
      expression: "codeBtnState==CONF.mobileCodeState.enable&&!sendMsgs"
    }],
    staticClass: "btn active",
    on: {
      "click": function($event) {
        return _vm.showImgCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.CONF.mobileCodeTxt.enable))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeBtnState == _vm.CONF.mobileCodeState.disable),
      expression: "codeBtnState==CONF.mobileCodeState.disable"
    }],
    staticClass: "btn disable"
  }, [_vm._v(_vm._s(_vm.CONF.mobileCodeTxt.disable))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeBtnState == _vm.CONF.mobileCodeState.timeout),
      expression: "codeBtnState==CONF.mobileCodeState.timeout"
    }],
    staticClass: "btn disable"
  }, [_vm._v(_vm._s(_vm.CONF.mobileCodeTxt.timeout) + "(" + _vm._s(_vm.timer) + "s)")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errMsgShow && !_vm.isMobile),
      expression: "errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.errMsg))])])])
},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content resetpwd"
  }, [_c('div', {
    staticClass: "title font-size24 color-msg"
  }, [_vm._v("重置密码")]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("请重设您的帐号密码")]), _vm._v(" "), _c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('div', {
    staticClass: "account-ipt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "新密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "focus": _vm.pwdFocus,
      "blur": _vm.pwdBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pwdData.errMsgShow && !_vm.isMobile),
      expression: "pwdData.errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.pwdData.errMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "account-ipt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repwd),
      expression: "repwd"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "确认新密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.repwd)
    },
    on: {
      "focus": _vm.repwdFocus,
      "blur": _vm.repwdBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.repwdData.errMsgShow && !_vm.isMobile),
      expression: "repwdData.errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.repwdData.errMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg bottom-cue"
  }, [_vm._v("密码长度6-20位，数字、字母、_至少包含两种")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: " submitBtnState==CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": _vm.resetPwd
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: " submitBtnState==CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("确 定")])])])])
},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other-way"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "other-way-option"
  }, [_c('a', {
    attrs: {
      "href": _vm.CONF.APIList.QQLogin + _vm.search + '&channel=' + _vm.channel
    }
  }, [_c('div', {
    staticClass: "option-qq option"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.CONF.APIList.WXLogin + _vm.search + '&isMobile=' + _vm.isMobile + '&channel=' + _vm.channel
    }
  }, [_c('div', {
    staticClass: "option-wx option"
  })]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other-way-txt"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt font-size14 color-cue"
  }, [_vm._v("其他登录方式")])])
}]}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content login"
  }, [_c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('mobile-input', {
    attrs: {
      "inputType": _vm.CONF.inputType.mobileOrEmail,
      "errData": _vm.errData
    },
    on: {
      "btnEnable": _vm.btnEnable,
      "btnDisable": _vm.btnDisable,
      "hideImgCode": _vm.getNcode
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-ipt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: {
      'error': _vm.errMsgShow
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": _vm.pwdFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errMsgShow && !_vm.isMobile),
      expression: "errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.errMsg))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: "submitBtnState == CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: "submitBtnState == CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-cue color-cue font-size14"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.CONF.urlList.ResetGetAccount.path + _vm.search
    }
  }, [_vm._v("忘记密码？")])], 1), _vm._v(" "), _c('other-way', [_c('div', {
    staticClass: "option-account font-size14 color-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.CONF.urlList.LoginCode.path + _vm.search
    }
  }, [_vm._v("手机短信登录>")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content resetpwd"
  }, [_c('div', {
    staticClass: "title font-size24 color-msg"
  }, [_vm._v("重置成功")]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("恭喜您，帐号"), _c('span', [_vm._v(_vm._s(_vm.account))]), _vm._v("密码重置成功")]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg bottom-cue"
  }, [_vm._v(_vm._s(_vm.timer) + "S自动跳转登录，"), _c('span', {
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("立即跳转>")])])])])
},staticRenderFns: []}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('mobile-input', {
    attrs: {
      "inputType": _vm.CONF.inputType.mobile,
      "errData": _vm.errData
    },
    on: {
      "btnEnable": _vm.btnEnable,
      "btnDisable": _vm.btnDisable,
      "hideImgCode": _vm.hideImgCode
    }
  }), _vm._v(" "), _c('img-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgCodeShow),
      expression: "imgCodeShow"
    }],
    attrs: {
      "options": _vm.imgCodeData
    },
    on: {
      "mobileCodeSendSuccess": _vm.mobileCodeSendSuccess
    }
  }), _vm._v(" "), _c('mobile-code', {
    attrs: {
      "mobileCodeBtnState": _vm.mobileCodeBtnState,
      "sendMsg": _vm.sendMsg,
      "inputType": _vm.CONF.inputType.mobile,
      "codeErrData": _vm.codeErrData,
      "sendMsgTimer": _vm.sendMsgTimer
    },
    on: {
      "mobileCodeBtnEnable": _vm.mobileCodeBtnEnable,
      "mobileCodeSuccess": _vm.mobileCodeSuccess,
      "showImgCode": function($event) {
        return _vm.showImgCode()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendOneMsg && _vm.countryCodeIndex == 0),
      expression: "sendOneMsg&&countryCodeIndex==0"
    }],
    staticClass: "font-size12 color-cue voice"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendVoiceMsgBtnState == _vm.CONF.mobileCodeState.enable),
      expression: "sendVoiceMsgBtnState== CONF.mobileCodeState.enable"
    }]
  }, [_vm._v("收不到短信，"), _c('span', {
    staticClass: "color-voice",
    on: {
      "click": function($event) {
        return _vm.showImgCode(true)
      }
    }
  }, [_vm._v("获取语音验证码")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendVoiceMsgBtnState == _vm.CONF.mobileCodeState.disable),
      expression: "sendVoiceMsgBtnState== CONF.mobileCodeState.disable"
    }]
  }, [_vm._v("收不到短信，"), _c('span', [_vm._v("获取语音验证码")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendVoiceMsgBtnState == _vm.CONF.mobileCodeState.timeout),
      expression: "sendVoiceMsgBtnState== CONF.mobileCodeState.timeout"
    }]
  }, [_vm._v(_vm._s(_vm.voiceTimer) + "s后可重新获取")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: "submitBtnState == CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: "submitBtnState == CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-cue color-cue font-size14"
  }, [_vm._v("首次使用验证码登录直接注册新帐号")]), _vm._v(" "), _c('other-way', [_c('div', {
    staticClass: "option-account font-size14 color-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.CONF.urlList.Login.path + _vm.search
    }
  }, [_vm._v("帐号密码登录>")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content resetpwd"
  }, [_c('div', {
    staticClass: "title font-size24 color-msg"
  }, [_vm._v("找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('mobile-input', {
    attrs: {
      "inputType": _vm.CONF.inputType.mobileOrEmail,
      "errData": _vm.errData
    },
    on: {
      "btnEnable": _vm.btnEnable,
      "btnDisable": _vm.btnDisable,
      "hideImgCode": _vm.hideImgCode
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: "submitBtnState==CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": function($event) {
        return _vm.getAccount()
      }
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: "submitBtnState==CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("下一步")])])])
},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toast toast-show",
    class: {
      'show': _vm.toastShow
    },
    attrs: {
      "id": "toast"
    }
  }, [_vm._v(_vm._s(_vm.toastMsg))])
},staticRenderFns: []}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content resetpwd"
  }, [_c('div', {
    staticClass: "title font-size24 color-msg"
  }, [_vm._v("安全验证")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.inputType === _vm.CONF.inputType.mobile),
      expression: "this.inputType === CONF.inputType.mobile"
    }],
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("请使用手机"), _c('span', [_vm._v(_vm._s(_vm.account))]), _vm._v("获取验证码")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.inputType === _vm.CONF.inputType.mobileOrEmail),
      expression: "this.inputType === CONF.inputType.mobileOrEmail"
    }],
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("请使用邮箱"), _c('span', [_vm._v(_vm._s(_vm.account))]), _vm._v("获取验证码")]), _vm._v(" "), _c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('img-code', {
    attrs: {
      "imgCodeErrData": _vm.imgCodeErrData,
      "options": _vm.imgCodeData
    },
    on: {
      "imgCodeSuccess": _vm.imgCodeSuccess
    }
  }), _vm._v(" "), _c('mobile-code', {
    attrs: {
      "mobileCodeBtnState": _vm.mobileCodeBtnState,
      "inputType": _vm.CONF.inputType.mobileOrEmail,
      "imgCode": _vm.imgCode,
      "codeErrData": _vm.codeErrData
    },
    on: {
      "mobileCodeSuccess": _vm.mobileCodeSuccess,
      "mobileCodeSendFail": _vm.mobileCodeSendFail
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: " submitBtnState==CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": _vm.verificationCode
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: " submitBtnState==CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("确 定")])])])
},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toast"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-ipt"
  }, [_c('div', {
    staticClass: "left-part short-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgCode),
      expression: "imgCode"
    }],
    staticClass: "input",
    class: {
      'error': _vm.errMsgShow
    },
    attrs: {
      "placeholder": "图片验证码",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.imgCode)
    },
    on: {
      "blur": function($event) {
        return _vm.imgCodeBlur()
      },
      "focus": function($event) {
        return _vm.imgCodeFocus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-part"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    },
    on: {
      "click": _vm.imgCodeChange
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errMsgShow && !_vm.isMobile),
      expression: "errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.errMsg))])])])
},staticRenderFns: []}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "userinfo"
  }, [_vm._v("该功能已下线\n  ")])])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_vm._v("努力加载中…")])])
}]}

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[47]);


// WEBPACK FOOTER //
// static/js/app.a89a8d0658974f268c28.js